import {IParams, RecursosController} from "../recursos";

declare global {
    interface Window {
        twttr: any;
    }
}

export class TwitterController extends RecursosController {

    /* INSTANCE */
    public static instance: TwitterController;

    /* STATIC */
    public static override async build(): Promise<void> {
        TwitterController.instance = new this();
        RecursosController.instances.push(TwitterController.instance);
    }

    constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='twitter-twit']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement): Promise<void> {
        const urls: IParams[] = [{name: "script-twitter", value: "https://platform.twitter.com/widgets.js"}];
        const promesas = await this.initPromises(urls);
        await Promise.all(promesas).then(async()=>{
            const twId = this.getTweetId(item);
            await this.loadTweet(twId, item.id);
        });
    }

    private getTweetId(container: HTMLElement): string {
        const params = JSON.parse(container.getAttribute('data-lazy')!.replace(/'/g,"\""));
        return params.id.split("status/")[1];
    }

    private async loadTweet(tweetId: string, containerId: string): Promise<void> {
        if (this.providerItems[containerId]) {
            document.getElementById(containerId)!.innerHTML = (await this.providerItems[containerId]).outerHTML;
        } else {
            this.providerItems[containerId] = window.twttr.widgets.createTweet(
                tweetId,
                document.getElementById(containerId),
            );
        }
    }

}
